import { IUrlModel } from './Types';

export default (urlModel: IUrlModel) => {
  const { url } = urlModel;

  return {
    url: url && String(url),
  };
};
